<script setup>
import Button from 'primevue/button';
import { ref } from 'vue';
import { usePage } from '@inertiajs/vue3';

const changePlan = () => {
    window.location = `${usePage().props.olympus.account_url}/client/subscriptions`;
};
</script>

<template>
    <div class="flex flex-col items-center justify-center md:pt-44 position-fixed top-0 text-center px-4">
        <div class="max-w-lg  p-8 rounded-lg border dark:border-neutral-700">
            <i class="pi pi-exclamation-triangle text-yellow-800 !text-xl px-3 rounded-xl bg-yellow-200 mb-4 p-2"></i>
            <h1 class="text-3xl font-bold text-gray-800 dark:text-gray-200 mb-4">{{ $t('forms.cannot_add_more_title') }}</h1>
            <p class="text-gray-600 dark:text-gray-200 !leading-6 mb-6">
                {{ $t('forms.cannot_add_more_desc1') }}
                {{ $t('forms.cannot_add_more_desc2') }}
            </p>
            <Button
                :label="$t('forms.cannot_add_more_btn')"
                :severity="'contrast'"
                icon="pi pi-arrow-up-right"
                icon-pos="right"
                @click="changePlan"
            />
        </div>
    </div>
</template>

<style scoped lang="scss">
</style>
